import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from '../language/en.json';
import tc from '../language/tc.json';
import Backend from 'i18next-http-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';

const detectionOptions = {
  order: ['path', 'cookie', 'navigator', 'localStorage', 'subdomain', 'queryString', 'htmlTag'],
  lookupFromPathIndex: 0

}

const resources = {
  en,
  tc
};

i18n
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // defaultNS: 'common',
    // ns: ['login', 'register'],
    resources,
    // lng: "en",
    fallbackLng: ['en', 'tc'],
    detection: detectionOptions,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      wait: true,
      useSuspense: false,
    },
    debug: true,
    returnObjects: true,
    keySeparator: '.', // we do not use keys in form messages.welcome
  });

export default i18n;
